module.exports = __webpack_public_path__ + "img/pig.be5030ca.webp";